import { createContext } from 'react';

const RatingsContext = createContext();

export default RatingsContext;
